module.exports = __webpack_public_path__ + "img/clock_b.015163d9.svg";